import script from "./InstitucionalView.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitucionalView.vue?vue&type=script&setup=true&lang=js"

import "./InstitucionalView.vue?vue&type=style&index=0&id=9e752cb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e752cb8"]])

export default __exports__